import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"

import * as actions from "./actions"

import Notifications from "./components/Notifications"
import { IOldUIInit } from "../../global"

interface OldUIInit extends IOldUIInit {
    error: (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ) => void
    information: (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ) => void
    warning: (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ) => void
    clear: (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ) => void
}

const init = (store: AppStore): OldUIInit => {
    const start = (): void => {
        store.dispatch(actions.initialize())
        const element = document.getElementById("notifications")

        if (element) {
            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <Notifications />
                </Provider>,
            )
        }
    }

    const error = (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ): void => {
        store.dispatch(
            actions.addErrorNotification(
                message,
                overwriteExisting,
                autoRemove,
                attrs,
            ),
        )
    }

    const information = (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ): void => {
        store.dispatch(
            actions.addInformationNotification(
                message,
                overwriteExisting,
                autoRemove,
                attrs,
            ),
        )
    }

    const warning = (
        message: string,
        overwriteExisting: boolean,
        autoRemove: number | undefined,
        ...attrs: string[]
    ): void => {
        store.dispatch(
            actions.addWarningNotification(
                message,
                overwriteExisting,
                autoRemove,
                attrs,
            ),
        )
    }

    const clear = (): void => {
        store.dispatch(actions.removeAllMessages())
    }

    return {
        start,
        error,
        information,
        warning,
        clear,
    }
}

export default init
